import React from 'react';
import type { CustomFormFieldComponentProps } from '../../types/types';
import ColorOpacityInput from './ColorOpacityInput';

interface ColorOpacityValue {
  color: string;
  opacity: number;
}

const ColorOpacityInputWrapper: React.FC<CustomFormFieldComponentProps & { value?: ColorOpacityValue, onChange?: (value: ColorOpacityValue) => void }> = ({
  value,
  onChange,
}) => {
  // This wrapper adapts the props from Ant Design's Form.Item (value, onChange)
  // to the props expected by the original ColorOpacityInput.
  return <ColorOpacityInput value={value} onChange={onChange} />;
};

export default ColorOpacityInputWrapper;